import store from '@/store';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper';
import { IAccess, IAccessListItem, AccessResponseType } from '@/entity/salons/access.types';
import { AccessRequestType } from '@/form/salonGeneral/access.types';
import { AccessUpdateRequestType } from '@/form/salonGeneral/accessUpdate.types';

@Module({
    namespaced: true,
    name: 'access',
    store,
    dynamic: true
})

class AccessModule extends VuexModule implements IStoreReady  {
    access: IAccess | null = null
    accessItem: IAccessListItem | null = null
    accessLoaded = false
    accessItemLoaded = false
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ access: IAccess;  accessLoaded: boolean }> {
        let accessLoaded = false;
        const access = await store.$repository.access.fetchAll(prepareFormData(data));
        if(access){
            accessLoaded = true;
        }
        return { access, accessLoaded}
    }

    @MutationAction
    async fetchData(data?: PaginationRequestType): Promise<{ accessItem: IAccessListItem;  accessItemLoaded: boolean }> {
        let accessItemLoaded = false;
        const accessItem = await store.$repository.access.fetchData(prepareFormData(data));
        if(accessItem){
            accessItemLoaded = true;
        }
        return { accessItem, accessItemLoaded}
    }

    @Action({rawError: true})
    async create(data: AccessRequestType): Promise<ResponseDataType> {
        console.log(data);
        return await store.$repository.access.create(data);
    }
    @Action({rawError: true})
    async update(data: AccessUpdateRequestType): Promise<ResponseDataType> {
        return await store.$repository.access.update(data);
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        return await store.$repository.access.delete(data);
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
    
}

export const AccessStore = getModule(AccessModule);